/**
 * Mini gráfico SVG inline de presión y velocidad del trazo a lo largo
 * del tiempo. Sin libs externas — se renderiza directo a SVG.
 */
interface Sample {
  x: number
  y: number
  t: number
  pressure: number
}

export function BiometricChart({ samples }: { samples: Sample[] }) {
  if (samples.length < 2) return null

  const W = 600, H = 120, P = 24
  const totalT = samples[samples.length - 1].t

  // Velocidad punto a punto (px/ms)
  const velocities: number[] = [0]
  for (let i = 1; i < samples.length; i++) {
    const a = samples[i - 1], b = samples[i]
    const dt = b.t - a.t || 1
    const d = Math.hypot(b.x - a.x, b.y - a.y)
    velocities.push(d / dt)
  }
  const vMax = Math.max(...velocities, 0.1)

  const xAt = (t: number) => P + ((t / totalT) * (W - 2 * P))
  const yPressure = (p: number) => H - P - p * (H - 2 * P)
  const yVelocity = (v: number) => H - P - (v / vMax) * (H - 2 * P)

  const pressurePath = samples
    .map((s, i) => `${i === 0 ? 'M' : 'L'}${xAt(s.t).toFixed(1)},${yPressure(s.pressure).toFixed(1)}`)
    .join(' ')
  const velocityPath = samples
    .map((s, i) => `${i === 0 ? 'M' : 'L'}${xAt(s.t).toFixed(1)},${yVelocity(velocities[i]).toFixed(1)}`)
    .join(' ')

  return (
    <div className="bg-legal-50 dark:bg-legal-900/40 rounded p-2">
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" className="block">
        {/* Grilla */}
        <line x1={P} y1={H - P} x2={W - P} y2={H - P} stroke="#cbd5e1" strokeWidth="0.5" />
        <line x1={P} y1={P} x2={P} y2={H - P} stroke="#cbd5e1" strokeWidth="0.5" />

        {/* Velocidad (azul) */}
        <path d={velocityPath} fill="none" stroke="#3b82f6" strokeWidth="1.5" />
        {/* Presión (verde) */}
        <path d={pressurePath} fill="none" stroke="#10b981" strokeWidth="1.5" />

        {/* Labels */}
        <text x={P + 4} y={P + 10} fontSize="9" fill="#3b82f6" fontWeight="600">— Velocidad</text>
        <text x={P + 4} y={P + 22} fontSize="9" fill="#10b981" fontWeight="600">— Presión</text>
        <text x={W - P - 50} y={H - P + 14} fontSize="8" fill="#94a3b8">{totalT.toFixed(0)}ms</text>
      </svg>
    </div>
  )
}
